import React from 'react';
import styled from "@emotion/styled";
import { Link } from 'gatsby';
import dimensions from 'styles/dimensions';
import colors from "styles/colors";
import Arrow from '../../vectors/arrow.svg';
import Illustration from 'components/_ui/Illustration';

const CardContainer = styled(Link)`
  display: block;
  padding: 3.2rem 1.6rem;
  transition: box-shadow 0.2s ease-out;
  
  &:hover {
    box-shadow: 0 0.5rem 1.2rem rgba(0,0,0,0.08);
    
    svg {
      opacity: 1;
      visibility: visible;
      top: 48%;
      transition: opacity 0.12s ease-in-out, top 0.2s ease-out, visibility 0s 0s;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    height: 100%;
    padding: 4.8rem 3.2rem;
    
    &.Card--condensed {
      padding: 3.2rem 2.4rem;  
    }
  }
`;

const CardIllustration = styled.div`
  width: 100%;
  max-width: 18.4rem;
  margin: 0 auto;
  user-select: none;
  pointer-events: none;
  
  & + * {
    margin-top: 3.2rem;
  }
  
  img {
    width: 100%;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    max-width: 22.4rem;
  }
`;

const CardContent = styled.div`
  text-align: center;
  
  h4 {
    position: relative;
    display: inline-block;
    
    & + * {
      margin-top: 0.8rem;
    }
  }
  
  svg {
    display: block;
    opacity: 0;
    visibility: hidden;
    width: 2.8rem;
    height: 2rem;
    fill: ${colors.red500};
    position: absolute;
    left: calc(100% + 1.6rem);
    top: 60%;
    transform: translateY(-50%);
    transition: opacity 0.12s ease-in-out, top 0.2s ease-out, visibility 0s 0.12s;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    h4 {
      & + * {
        margin-top: 1.6rem;
      }
    }
    
    .Card--condensed & {
      h4 {
        font-size: 1.8rem;
      }
      
      p {
        font-size: 1.6rem;
      }
      
      svg {
        width: 2rem;
        height: 1.4rem;
        top: 44%;
      }
    }
  }
`;

const CardSolution = ({ destination, image, illustration, name, text, variant }) => {
  return (
    <CardContainer
      to={destination}
      className={variant ? `Card--${variant}` : ''}
    >
      <CardIllustration>
        {illustration && (
          <Illustration source={illustration}/>
        )}

        {(!illustration && image) && (
          <img src={image.url} alt={image.alt} loading="lazy" />
        )}
      </CardIllustration>

      <CardContent>
        <h4>{name} <Arrow/></h4>
        <p>{text}</p>
      </CardContent>
    </CardContainer>
  );
};

export default CardSolution;
